import { StepStatus } from '../types/rankAList';

export const getStepStatus = (currentStep: number, stepNumber: number): 'pending' | 'current' | 'complete' => {
  if (currentStep > stepNumber) return 'complete';
  if (currentStep === stepNumber) return 'current';
  return 'pending';
};

export const getStepNumber = (baseStep: number, approach: 'prediction' | 'similarity') => {
  if (approach === 'similarity' && baseStep >= 5) {
    return baseStep - 1;
  }
  return baseStep;
};

export const toggleStep = (stepNumber: number, expandedSteps: number[], setExpandedSteps: (steps: number[]) => void) => {
  setExpandedSteps(
    expandedSteps.includes(stepNumber) 
      ? expandedSteps.filter(s => s !== stepNumber)
      : [...expandedSteps, stepNumber]
  );
}; 